module.exports = __webpack_public_path__ + "assets/img/pay-guide-ios.c203f308.png";